import React, {useState} from 'react';
import classNames from 'classnames';
import BackButton from './BackButton';
import Icon from './Icon';
import Rule from './Rule';
import NavLink from './NavLink';
import ActiveFlag from './ActiveFlag';
import isLinkActive from './isLinkActive';

function TertiaryPage({navMenu, onClose}) {
    return (
        <div>
            {!navMenu ? null : (
                <>
                    <BackButton onClick={onClose}/>
                    <NavLink {...navMenu}/>
                    <Rule/>
                    {!navMenu.links ? null : navMenu.links.map((link, index) => (
                        <div key={index} className="position-relative">
                            {!link.active ? null : <ActiveFlag className="py-3 pl-2"/>}
                            <a className="btn btn-link"
                                data-category={link.dataCategory}
                                data-action={link.dataAction}
                                data-label={link.dataLabel}
                               href={link.url}>
                                <span className="lead">{link.title}</span>
                                {!link.description ? null : (
                                    <span className="d-block pt-2 pl-3 pr-5">{link.description}</span>
                                )}
                            </a>
                        </div>
                    ))}
                </>
            )}
        </div>
    );
}

function SecondaryPage({navMenu, onClose}) {
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [open, setOpen] = useState(selectedIndex >= 0);
    return (

        <section className={classNames({
            'leaflet': true,
            'leaflet-open': open,
        })}>
            <div className="leaflet-page">
                {!navMenu ? null : (
                    <>
                        <BackButton onClick={onClose}/>
                        <NavLink {...navMenu}/>
                        <Rule/>
                        {!navMenu.links ? null : navMenu.links.map((link, index) => (
                            <div key={index} className="position-relative">
                                {!isLinkActive(link) ? null : <ActiveFlag className="py-3 pl-2"/>}
                                {link.links && link.links.length > 0 ? (
                                    <button
                                        className="btn btn-link btn-block"
                                        onClick={() => {
                                            setSelectedIndex(index);
                                            setOpen(true);
                                        }}>
                                        <span>{link.title}</span>
                                        <Icon.CaretRight/>
                                    </button>
                                ) : (
                                    <a
                                        className="btn btn-link btn-block"
                                        data-category={link.dataCategory}
                                        data-action={link.dataAction}
                                        data-label={link.dataLabel}
                                        href={link.url}>
                                        <span>{link.title}</span>
                                    </a>
                                )
                                }
                            </div>
                        ))}
                    </>
                )}
            </div>
            <div className="leaflet-page">
                <TertiaryPage navMenu={selectedIndex < 0 ? null : navMenu.links[selectedIndex]}
                              onClose={() => setOpen(false)}
                />
            </div>
        </section>

    );
}

export default (props) => {
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [open, setOpen] = useState(selectedIndex >= 0);
    return (
        <section className={classNames({
            'leaflet': true,
            'leaflet-open': open,
        })}>

            <div className="leaflet-page">
                {props.navMenu.links.map((link, index) => (
                    <div key={index} className="bg-primary-grad position-relative">
                        {!isLinkActive(link) ? null : <ActiveFlag className="py-4 pl-2"/>}
                        <button
                            className="btn btn-link btn-block py-4"
                            onClick={() => {
                                setSelectedIndex(index);
                                setOpen(true);
                            }}>
                            <span className="h5 mb-0 font-weight-black">{link.title}</span>
                            <Icon.CaretRight/>
                        </button>
                    </div>
                ))}
                <ul className="nav d-inline-flex d-md-none my-3">
                    {props.navMenu.quickLinks.map((link, i) => (
                        <li key={i} className="nav-item">
                            <a className="nav-link"
                            data-category={link.dataCategory}
                            data-action={link.dataAction}
                            href={link.url}>{link.title}</a>
                        </li>
                    ))}
                </ul>
            </div>

            <div className="leaflet-page">
                <SecondaryPage navMenu={selectedIndex < 0 ? null : props.navMenu.links[selectedIndex]}
                               onClose={() => setOpen(false)}
                />
            </div>

        </section>
    )
};
